import { FC, HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

import Alert from '@/assets/icons/Alert';

import styles from '../Fields.module.css';

type FieldErrorProps = HTMLAttributes<HTMLDivElement> & {
  errorMessage?: string | ReactNode;
  className?: string;
  width?: 'auto' | 'full';
};

const ValidationError: FC<FieldErrorProps> = ({ errorMessage, className, width, ...divProps }) =>
  errorMessage !== '' && errorMessage ? (
    <div
      role='alert'
      className={clsx(
        styles.error,
        width === 'auto' && styles['error--width-auto'],
        width === 'full' && styles['error--width-full'],
        className,
      )}
      {...divProps}
    >
      <Alert fill='var(--tractie-color-content-error)' width='16px' height='16px' aria-hidden='true' />
      <span>{errorMessage}</span>
    </div>
  ) : null;

export default ValidationError;
